import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

import { palette, breakPoint } from '@mirinae/react-ui';

export const AuthPopupLayer = styled.div`
    ${props => (props.theme !== 'popup') && `
        box-shadow: 0px 0px 15px rgba(196, 196, 196, 0.48);
        border-radius: 15px;
        padding: 40px 55px;
        background: #FFFFFF;
    `}
    position: relative;
    max-width: 382px;
    width: 100%;
    height: 100%;

    @media only screen and (max-width: ${breakPoint.common.md}) {
        // max-width: 272px;
        margin: auto;
        padding: 40px 30px 20px;
        border-radius: 0;
        box-shadow: none;
    }
    @media only screen and (max-width: ${breakPoint.common.sm}) {
        padding-left: 20px;
        padding-right: 20px;
    }
`;

export const AuthPopupWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const PopupTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const PopupTitle = styled.p`
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
`;

export const PopupTitleDesc = styled.p`
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: ${palette.gray[2]};
    //line-height: 6px;

    strong {
        font-weight: 500;
    }
`;

export const PopupContentDesc = styled.p`   
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${palette.gray[4]};
`;

export const PopupBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const AuthColForms = styled.div`
    position: relative;
`;

export const AuthColDiv = styled.div`
    width: 100%;
    height: 12px;
    line-height: 12px;
    color: ${palette.point.gray};
    font-weight: 700;
    font-size: 10px;
    text-align: center;
    background-image: linear-gradient(
        to right,
        #d8d8d8 0,
        #d8d8d8 calc(50% - 21px),
        transparent calc(50% - 21px),
        transparent calc(50% + 21px),
        #d8d8d8 calc(50% + 21px),
        #d8d8d8 100%);
    background-size: 100% 1px;
    background-position: 0 50%;
    background-repeat: no-repeat;
`;

export const FormRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    &:hover {
        label{
            color: ${palette.main.main};
        }
        div {
            span {
                svg path{
                    fill: ${palette.main.main} !important;
                }
            }
        }
    }
`;

export const FormLabel = styled.label`
    color: ${palette.gray[4]};
    font-weight: 600;
    font-size: 11px;
    line-height: 13px;
  
    @media only screen and (max-width: ${breakPoint.common.md}) {
        font-size: 14px;
    }
`;

export const FormEmailWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 20px 0 16px;
    border-radius: 10px;
    background-color: #F9F9F9;
    ${(props) => (props.isFocused && `outline: 1px solid ${palette.main.main}`)};
    ${(props) => (props.userFound && `outline: 1px solid ${palette.warning.default}`)};
  
    @media only screen and (max-width: ${breakPoint.common.md}) {
        max-height: 57px;
        height: fit-content;
        padding: 15px 20px 15px 16px;
    }

    input {
        width: 100%;
        height: 40px;
        border: none;
        background-color: transparent;
        color: ${palette.gray[1]};
        font-weight: 400;
        font-size: 13px;
      
        @media only screen and (max-width: ${breakPoint.common.md}) {
            font-size: 16px;
        }
    }
    input:-webkit-autofill{
        -webkit-text-fill-color: ${palette.gray[1]} !important;
    }
    input::placeholder {
        color: ${palette.gray[5]};
    }
`;

export const FormProfileWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 20px 0 16px;
    border-radius: 10px;
    background-color: #F9F9F9;
    ${(props) => (props.isFocused && `outline: 1px solid ${palette.main.main}`)};
    ${(props) => (props.userFound && `outline: 1px solid ${palette.warning.default}`)};
  
    @media only screen and (max-width: ${breakPoint.common.md}) {
        height: fit-content;
        max-height: 57px;
        padding: 15px 20px 15px 16px;
    }

    input {
        width: 100%;
        height: 40px;
        border: none;
        background-color: transparent;
        color: ${palette.gray[1]};
        font-weight: 400;
        font-size: 13px;
      
        @media only screen and (max-width: ${breakPoint.common.md}) {
            font-size: 16px;
        }
    }
    input:-webkit-autofill{
        -webkit-text-fill-color: ${palette.gray[1]} !important;
    }
    input::placeholder {
        color: ${palette.gray[5]};
    }
`;


export const FormPasswordWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 15px 0 16px;
    border-radius: 10px;
    background-color: #F9F9F9;
    ${(props) => (props.isFocused && `outline: 1px solid ${palette.main.main}`)};
  
    @media only screen and (max-width: ${breakPoint.common.md}) {
        height: fit-content;
        max-height: 57px;
        padding: 15px 15px 15px 16px;
    }

    input {
        width: 100%;
        height: 40px;
        border: none;
        background-color: transparent;
        color: ${palette.gray[1]};
        font-weight: 400;
        font-size: 13px;
      
        @media only screen and (max-width: ${breakPoint.common.md}) {
            font-size: 16px;
        }
    }
    input:-webkit-autofill{
        -webkit-text-fill-color: ${palette.gray[1]} !important;
    }
    input::placeholder {
        color: ${palette.gray[5]};
    }
`;

export const FormBottom = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const FormIcon = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 16px;
    margin-right: 10px;
`;

export const FormError = styled.div`
    height: 12px;
    line-height: 14px;
    font-size: 10px;
    color: ${palette.warning.default};
    text-align: center;
    // display: contents;
    p {
        font-weight: 400;
        font-size: 10px;
        line-height: 12px;
        color: ${palette.warning.default};
    }
`;

export const AuthColBottom = styled.div``;

export const AuthColButtons = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 15px;
`;

export const LinkForgot = styled(Link)`
    color: #979797;
    font-size: 10px;
    text-decoration: underline;
`;

export const AuthButton = styled.div`
    width: 100%;
    & > button {
        width: 100%;
        height: 44px;
        padding: 10px 25px;
        border: 0;
        border-radius: 10px;
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
        color: #FFFFFF;
        background-color: ${palette.main.main};
        font-family: inherit;
        &:hover {
            background-color: ${palette.green.middle};
        }
        &:disabled {
            background-color: ${palette.gray.light};
        }   
        @media only screen and (max-width: ${breakPoint.common.md}) {
            height: 57px;
        }
    }
`;

export const AuthColLinks = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 11px;
    gap: 5px;
    color: ${palette.point.gray};
    button {
        border: 0;
        padding: 0;
        background-color: inherit;
        color: ${palette.green.middle};
        font-weight: 700;
        font-size: 13px;
        text-decoration: underline;
    }
  
    @media only screen and (max-width: ${breakPoint.common.md}) {
        font-size: 12px;
        button {
            font-size: 14px;
        }
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: space-between;
    width: 260px;
    margin: 0 auto;

    @media only screen and (max-width: ${breakPoint.common.md}) {
        width: 100%;
    }
`;

export const NestedLink = styled.p`
    font-weight: 500;
    font-size: 10px;
    line-height: 15px;
    color: ${palette.primary.black};

    a {
        color: ${palette.main.darken[1]}
    }
  
      @media only screen and (max-width: ${breakPoint.common.md}) {
        font-size: 12px;
    }

`;